/**
 * aminos-judgeme.js
 *
 * Judge.me owns the reviews widget markup. This stamps the same classes the
 * shop CTAs use (`btn btn--primary aminos-btn-shadow`) onto the load-more
 * control, and puts them back when Vue re-renders the pagination.
 */
(function (global) {
  'use strict';

  if (global.__aminosJudgeMeButtons) return;
  global.__aminosJudgeMeButtons = true;

  var CLASSES = ['btn', 'btn--primary', 'aminos-btn-shadow'];

  function paint(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var buttons = scope.querySelectorAll('.jm-load-more-pagination .jm-button');
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].classList.add.apply(buttons[i].classList, CLASSES);
    }
  }

  function start() {
    paint(document);

    if (!('MutationObserver' in global)) return;

    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (!node || node.nodeType !== 1) continue;

          if (node.matches && node.matches('.jm-load-more-pagination .jm-button')) {
            paint(node.closest('.jm-load-more-pagination'));
            return;
          }

          if (node.querySelector && node.querySelector('.jm-load-more-pagination .jm-button')) {
            paint(node);
          }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})(window);
